import SimpleSchema from "simpl-schema";
import {
  UUID,
  OptionalString,
  OptionalNumber,
  OptionalBoolean,
} from "./CustomTypes.js";

const PolygonFeatureSchema = new SimpleSchema({
  "type": String,
  "coordinates": Array,
  "coordinates.$": Array,
  "coordinates.$.$": {
    type: Array,
    minCount: 2,
  },
  "coordinates.$.$.$": "Number",
});

const MultiPolygonFeatureSchema = new SimpleSchema({
  "type": String,
  "coordinates": Array,
  "coordinates.$": Array,
  "coordinates.$.$": Array,
  "coordinates.$.$.$": {
    type: Array,
    minCount: 2,
  },
  "coordinates.$.$.$.$": Number,
});

const LandValuesSchema = new SimpleSchema({
  tillableAcres: Number,
  totalAcres: Number,
  soilIndex: Number,
  indexType: String,
  avgPrice: Number,
  lowPrice: Number,
  highPrice: Number,
});

const LocationSchema = new SimpleSchema({
  address: String,
  city: String,
  zipCode: {
    type: String,
    regEx: SimpleSchema.RegEx.ZipCode,
  },
  state: String,
  stateCode: OptionalString,
  county: String,
});

const GeoJSONSchema = new SimpleSchema({
  "type": String,
  "properties": Object,
  "properties.id": String,
  "properties.parentId": OptionalString,
  "properties.parcel_id": OptionalString,
  "properties.last_updated": OptionalString,
  "properties.name": OptionalString,
  "properties.owner": OptionalString,
  "properties.type": OptionalString,
  "properties.acres": OptionalNumber,
  "properties.relativeAcres": OptionalNumber,
  "properties.fmid_land_id": OptionalString,
  "properties.isForHunting": OptionalBoolean,
  "geometry": {
    type: SimpleSchema.oneOf(PolygonFeatureSchema, MultiPolygonFeatureSchema),
  },
});

const MapDataSchema = new SimpleSchema({
  id: {
    type: SimpleSchema.oneOf(String, SimpleSchema.Integer),
    optional: true,
  },
  internalId: {
    type: UUID,
    optional: true,
  },
});

MapDataSchema.extend(GeoJSONSchema);

const MapSchema = new SimpleSchema({
  // TODO: Needs to be checked, but layersInfo might
  // not be needed here as it is calculated on the backend
  "layersInfo": {
    type: Object,
    optional: true,
  },
  "layersInfo.totalAcres": OptionalNumber,
  "layersInfo.totalLength": OptionalNumber,
  "layersInfo.currentAcres": OptionalNumber,
  "layersInfo.currentLength": OptionalNumber,
  "viewport": Object,
  "viewport.center": {
    type: Array,
    minCount: 2,
    maxCount: 2,
  },
  "viewport.center.$": Number,
  "viewport.zoom": SimpleSchema.Integer,
  "data": Array,
  "data.$": MapDataSchema,
});

const FileItemSchema = new SimpleSchema({
  file_type: String,
  file_name: String,
  display_name: OptionalString,
  file_size: SimpleSchema.Integer,
  file_mime: String,
  fsa_mapenvelope: OptionalString,
  soil_mapenvelope: OptionalString,
  position: {
    type: SimpleSchema.Integer,
    defaultValue: 0,
    optional: true,
  },
  path: String,
  url: String,
});

const CreateFarmInput = new SimpleSchema({
  id: OptionalString,
  name: OptionalString,
  description: String,
  cityId: {
    type: SimpleSchema.Integer,
  },
  lat: Number,
  lng: Number,
  aerialMap: MapSchema,
  soilMap: {
    type: MapSchema,
    optional: true,
  },
  landValues: {
    type: LandValuesSchema,
    optional: true,
  },
  location: {
    type: LocationSchema,
    optional: true,
  },
});

export {
  CreateFarmInput,
  MapSchema,
  GeoJSONSchema,
  FileItemSchema,
};
